import React from 'react'
import { render } from 'react-dom'
import App from './App'

import store from './reducers'
import { Provider } from 'react-redux'

import Promise from 'promise-polyfill'

// To add to window
if (!window.Promise) {
  window.Promise = Promise
}

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('register-mount')
)


// WEBPACK FOOTER //
// ./src/index.js